import { Box, styled } from '@mui/material';

const ModalBody = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '81%',
  border: 'none',
  overflow: 'auto',
  maxWidth: '1190px',
  backgroundColor: theme.palette.background.paper,
  padding: '20px 40px 40px 40px',
  borderRadius: '6px',

  outline: 'none',
}));

export default ModalBody;
